import React from "react";
import { Routes, Route } from "react-router-dom";
import Methodologie from "./pages/methodologie/Methodologie";
import Navbar from "./components/Navbar/Navbar"; // Assure-toi que le chemin est correct
import CultureInnovation from "./pages/Accueil/CultureInovation";
import NosServices from "./pages/a_propos/NosServices/NosServices";
import Vision from "./pages/a_propos/Vision/Vision";
import Accueil from "./pages/accueil/Accueil";
import ContactForm from "./pages/Contact/Contact";
import PartenaireForm from "./pages/Partenaire/Partenaire";
import Banner from "./components/Banner/Banner";
import Footer from "./components/Footer/Footer";
import NavigationApropos from "./pages/NavigationApropos/NavigationApropos";
import AboutUs from "./pages/Accueil/AboutUs";
import CTAButton from "./components/Button/CTAButton/CTAButton";
import OutilNumerique from "./pages/a_propos/NosServices/OutilNumerique";
import Employabilite from "./pages/a_propos/NosServices/Employabilite";
import Transformation from "./pages/a_propos/NosServices/TransformationDigitale";
import VisiteAffaire from "./pages/a_propos/NosServices/VisiteAffaire";
import ScrollArrow from "./components/ScrollArrow/ScrollArrow";

//import Metier from './pages/accueil/Metier'
//import Tendance from './pages/accueil/Tendance'
const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/methodologie" element={<Methodologie />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/CultureInnovation" element={<CultureInnovation />} />
        <Route path="/service" element={<NosServices />} />
        <Route path="/" element={<Accueil />} />
        <Route path="/methodologie" element={<Methodologie />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/partenaire" element={<PartenaireForm />} />
        <Route path="/apropos" element={<NavigationApropos />} />
        {/* <Route path="/metier" element={<Metier />} /> */}
        {/* <Route path="/tendance" element={<Tendance />} /> */}
        <Route path="/outilNumerique" element={<OutilNumerique />} />
        <Route path="/employabilite" element={<Employabilite />} />
        <Route path="/transformation" element={<Transformation />} />
        <Route path="/visiteaffaire" element={<VisiteAffaire />} />
      </Routes>
      <Banner />
      <CTAButton />
      <ScrollArrow />
      <Footer />
    </>
  );
};

export default App;
